// extracted by mini-css-extract-plugin
module.exports = {"WrapperModal":"Modal_WrapperModal___m0QV","Overlay":"Modal_Overlay__dPxyI","opened":"Modal_opened__bf4H7","Content":"Modal_Content__GMbue"};